<template>
  <b-form-group class="form-group__buttons">
    <label class="col-form-label pt-0">
      Event type
    </label>
    <v-select
      :value="value"
      :options="eventTypesSelectOptions"
      :searchable="false"
      placeholder="Select Event Type"
      class="custom-select"
      @change="eventSelected"
    >
      <template slot="selected-option" slot-scope="option">
        {{ option.label }}
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
export default {
  name: 'FaultEventSelection',
  props: {
    value: Object,
    eventTypesSelectOptions: Array
  },
  methods: {
    eventSelected(changedValue) {
      this.$emit('eventChanged', changedValue);
    }
  }
};
</script>
